import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import LoaderCircle from '@/components/LoaderCircle'
import { useUser } from '@/context/UserProvider'
import { getAllSubscriptionPayments } from '@/store/subscriptionPayments/actions'
import { getSubscriptionStatus } from '@/utils/functions/getSubscriptionStatus'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'

import BLOCK_MESSAGES from './centreBlockMessages'

import s from './styles.module.scss'

const CentreBlockModal = ({ centreDetail }) => {
  const dispatch = useDispatch()
  const [status, setStatus] = useState('')

  const { user } = useUser()
  const isAdmin = user?.roles?.includes('admin')
  const { allSubscriptionPayments, isLoading } = useSelector((state) => state.subscriptionPayments)
  const blockCentreInfo = status?.length ? BLOCK_MESSAGES[status] : null

  useEffect(() => {
    getAllPayments()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!isLoading) {
      setStatusCentre(allSubscriptionPayments)
    }
  }, [allSubscriptionPayments, isLoading])

  const getAllPayments = async () => {
    const params = {
      centre: centreDetail?._id,
    }
    await dispatch(getAllSubscriptionPayments(params))
  }

  const setStatusCentre = (allSubscriptionPayments) => {
    const status = getSubscriptionStatus(allSubscriptionPayments)

    setStatus(status)
  }

  const getWhatsAppLink = (wappNum) => {
    return (
      <a href={wappNum} rel="noreferrer" target="_blank">
        <WhatsAppIcon className={s.fontIcon} /> Escribí al Whatsapp
      </a>
    )
  }

  if (isAdmin || !user) return

  return (
    <Dialog
      disableEscapeKeyDown={true}
      open={true}
      maxWidth="sm"
      classes={{ paper: s.paperProps, root: 'centre-block-pop-up' }}
    >
      {!blockCentreInfo ? (
        <div className={s.loading}>
          <LoaderCircle text="Cargando..." />
        </div>
      ) : (
        <>
          <DialogTitle className={s.title}>{blockCentreInfo.title}</DialogTitle>
          <DialogContent className={s.mainContainer}>
            <div className={s.mainP}>
              <p>{blockCentreInfo?.subTitle}</p>
            </div>
            <div className={s.containerImg}>
              <img className={s.img} src={blockCentreInfo?.img} alt="empty" />
            </div>
            <div className={s.mainP}>
              <p>
                {blockCentreInfo?.text} <br />{' '}
              </p>
              {getWhatsAppLink(blockCentreInfo?.wappNum)}
            </div>
          </DialogContent>
        </>
      )}
    </Dialog>
  )
}

export default CentreBlockModal
